<div class="container-fluid animated fadeIn is-step-wizard">
	<div class="row mt-5">
		<!-- STEPS TITLE -->
		<div class="col-12 mb-4">
			<div class="wiz-title">
				{{ 'upload-file.pageTitle' | translate }}
			</div>
		</div>
		<!--CONTENT -->
		<div class="col-12">
			<div class="simple-card top-line">
				<div class="row content-area">
					<div class="col-sm-8 col-lg-6 col-xl-5">
						<div class="material-input md-3">
							<select
								[(ngModel)]="fileUploadContentType"
								id="fileUploadContentType"
								name="fileUploadContentType"
								required
								(change)="onChangeFileUploadContentType()"
								class="text-truncate"
								data-e2e-upload-file-select-file-type>
								@if (fileUploadContentTypes.length > 1) {
									<option value=""></option>
								}
								@for (fileUploadContentType of fileUploadContentTypes; track $index) {
									<option [ngValue]="fileUploadContentType">
										{{ fileUploadContentType.TranslatedType }}
									</option>
								}
							</select>
							<label
								>{{ 'upload-file.FileUploadContentTypes' | translate }}
								@if (!!fileUploadContentTypeError) {
									<em>{{ 'field.required' | translate }}</em>
								}
							</label>
							<span></span>
						</div>
					</div>
					<div class="col-sm-8 col-lg-6 col-xl-5 mt-5">
						<label class="file-label">{{ 'upload-file.UploadBrowseFileInformation' | translate }}</label>
						<div class="upload-btn">
							<span
								id="filename"
								class="text-truncate"
								>{{ fileName }}</span
							>
							<label
								class="w-xs-100"
								(click)="selectFile()">
								<span><i class="fa-solid fa-file-upload"></i></span>
								<span class="p-0">{{ 'upload-file.UploadBrowseFile' | translate }}</span>
							</label>
							<!-- https://stackoverflow.com/a/46971427 : allowing upload if file name is same-->
							<input
								#fileInput
								type="file"
								id="file-upload"
								(change)="onFileChange($event)"
								(click)="fileInput.value = null"
								value=""
								class="mb-0"
								data-e2e-request-import-select-file-button />
						</div>
					</div>
				</div>
				<div class="divider"></div>
				<!-- BUTTONS AREA -->
				<div class="d-flex align-items-center justify-content-xs-center justify-content-end p-4">
					<div>
						<eif-custom-button
							[text]="'upload-file.goToPreviousStep' | translate"
							[preIcon]="'fa-light fa-chevron-left'"
							[color]="'neutral'"
							[class]="'mb-0'"
							(action)="navigateToFilesIntegrationSearch()">
						</eif-custom-button>
					</div>
					<div
						[hidden]="!showNextStep()"
						class="ms-3">
						<eif-custom-button
							[text]="'upload-file.Submit' | translate"
							[postIcon]="'fa-light fa-chevron-right'"
							[class]="'mb-0'"
							(action)="registerFileForProcessing()">
						</eif-custom-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
